import { render, staticRenderFns } from "./ColorEditor.vue?vue&type=template&id=7695a33d&scoped=true&"
import script from "./ColorEditor.vue?vue&type=script&lang=js&"
export * from "./ColorEditor.vue?vue&type=script&lang=js&"
import style0 from "./ColorEditor.vue?vue&type=style&index=0&id=7695a33d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7695a33d",
  null
  
)

export default component.exports